<!--
 * @Author: Junjie
 * @Date: 2022-08-24 17:27:47
 * @LastEditTime: 2022-08-25 00:14:43
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/monitor/points/modules/RelateModal.vue
-->
<template>
  <j-modal
    :okButtonProps="{ class:{'jee-hidden': false} }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
    switchFullscreen
  >
    <relate-modal-form @ok="submitCallback" normal ref="realForm"></relate-modal-form>
  </j-modal>
</template>



<script>

  import RelateModalForm from './RelateModalForm'

  export default {
    name: 'RelateModal',
    components: {
      RelateModalForm
    },
    data () {
      return {
        title: "操作",
        width: 896,
        visible: false,
      }
    },
    methods: {
      add () {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.add();
        })
      },
      edit (pointCodes) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.edit(pointCodes);
        });
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      submitCallback () {
        this.$emit('ok');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>

<style lang="less" scoped>
  /** Button按钮间距 */
  .ant-btn {
    margin-left: 30px;
    margin-bottom: 30px;
    float: right;
  }
  .drawer-footer {
    position: absolute;
    bottom: -8px;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    left: 0;
    background: #fff;
    border-radius: 0 0 2px 2px;
  }
</style>